import {
  CsvStepName,
  CsvStepState,
  CsvStorageStatusRes,
  SetupStatus,
} from "../../type/csv-status";

const EMPTY: SetupStatus = {
  hasUpload: false,
  isCompleted: false,
  blockingStep: null,
  blockingState: null,
  isProcessing: false,
  isFailed: false,
  isCanceled: false,
  errorCode: null,
  description: null,
  filename: null,
};

export class CsvStatusAdapter {
  /**
   * 応答を画面が使う形へ正規化する。
   *
   * `current_step` が「最初に success でない段」なので、止まっている段は
   * これをそのまま使える。`steps` から該当段を引いて state を取る。
   */
  static toOutputDTO(res: CsvStorageStatusRes | null | undefined): SetupStatus {
    const current = res?.current_step ?? null;

    // 未アップロード（識別子も current_step も無い）
    if (!current) {
      return { ...EMPTY, filename: res?.filename ?? null };
    }

    if (current === "completed") {
      return {
        ...EMPTY,
        hasUpload: true,
        isCompleted: true,
        filename: res?.filename ?? null,
      };
    }

    const blockingStep = current as CsvStepName;
    const step = (res?.steps ?? []).find((e) => e.step === blockingStep);
    const blockingState = (step?.state ?? null) as CsvStepState | null;

    return {
      hasUpload: true,
      isCompleted: false,
      blockingStep,
      blockingState,
      isProcessing: blockingState === "in_progress",
      isFailed: blockingState === "error",
      isCanceled: blockingState === "canceled",
      // error_code / description は失敗段にだけ入る
      errorCode: step?.error_code ?? null,
      description: step?.description ?? null,
      filename: res?.filename ?? null,
    };
  }
}
